export default {
  GAME: 'JUEGO',
  Winner: 'Ganador',
  Win: 'Ganar',
  Chance: 'Probabilidad',
  'Chance to win': 'Chance to win',
  'At stake': 'En el juego',
  'Sign in through STEAM to participate': 'Inicia sesión a través de STEAM para participar',
  'Steam trade link': 'Enlace de intercambio de Steam',
  'Your chance': 'Your chance',
  'Be first to deposit': 'Sea el primero en depositar',
  'Place a bet': 'Haga la apuesta',
  'Deposit more': 'Depositar más',
  'Min bet': 'Apuesta mín.',
  'Max bet': 'Apuesta máx.',
  'Bet amount': 'Monto de apuesta',
  'max. items': 'artículos máx.',
  Tickets: 'Tickets',
  from: 'from',
  to: 'to',
  'Tickets to from': 'Billetes: de #{{ from  }} a #{{ to }}',
  Skins: 'Skins',
  Coins: 'Monedas',
  'VIRTUAL SKINS': 'skins virtuales',
  'Round number': 'Número de ronda',
  'Winning after commission': 'Premio después de comisión',
  Loading: 'Cargando',
};
